import Axios from './baseApi';

export default {
  async create(person) {
    return await Axios.put('/api-master-data/v1/person', person);
  },
  async update(person) {
    return await Axios.post('/api-master-data/v1/person/update', person);
  },
  async addToFactory(factoryId, personId) {
    return await Axios.post('/api-master-data/v1/personInFactory/' + factoryId,
      {id: personId});
  },
  async removeFromFactory(factoryId, personId) {
    return await Axios.delete(`/api-master-data/v1/personInFactory/${factoryId}/${personId}`);
  },
  async fetch(personId) {
    return await Axios.get(`/api-master-data/v1/person/by-id/${personId}`);
  },
  async fetchVeterinarians(factoryId) {
    return await Axios.get(`/api-master-data/v1/veterinarian/${factoryId}`);
  },
  async remove(personId) {
    return await Axios.delete(`/api-master-data/v1/person/${personId}`);
  }
}
